import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { DEFAULT_BASE_CHARGE_LIMIT } from "src/constants/facility";
import meta from "src/utils/meta";

export interface UseFacilityMaximumChargeRateProps {
  workerType?: string;
}

export function useFacilityMaximumChargeRates() {
  const customChargeRates = useCbhFlag(CbhFeatureFlag.MAXIMUM_ALLOWED_WORKPLACE_CHARGE_RATES, {
    defaultValue: {},
  });

  const baseChargeLimit = { ...meta().baseChargeLimit, ...customChargeRates };

  return {
    maximumChargeRates: baseChargeLimit,
    defaultBaseChargeLimit: DEFAULT_BASE_CHARGE_LIMIT,
  };
}

export function useFacilityMaximumChargeRate(props: UseFacilityMaximumChargeRateProps) {
  const { workerType } = props;

  const customChargeRates = useCbhFlag(CbhFeatureFlag.MAXIMUM_ALLOWED_WORKPLACE_CHARGE_RATES, {
    defaultValue: {},
  });

  const baseChargeLimit = { ...meta().baseChargeLimit, ...customChargeRates };

  return {
    maximumChargeRate:
      (workerType ? baseChargeLimit[workerType] : undefined) ?? DEFAULT_BASE_CHARGE_LIMIT,
  };
}
